import { sendToApi } from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { UseQueryOptions, useQuery } from 'react-query'
import { BrandKit } from 'types'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'

interface Data {
  brand_kits: BrandKit[]
}

export const fetchBrandKits = async (workspaceId: number) => {
  const res = await sendToApi<Data>(`/w/${workspaceId}/brand_kits`)
  if (res.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error(res.data)
  }
  return res.data
}

export const useBrandKits = (options?: UseQueryOptions<BrandKit[]>) => {
  const currentWorkspaceId = useCurrentWorkspaceId()

  return useQuery<BrandKit[]>(
    ['workspaces', currentWorkspaceId, 'brandKits', 'list'],
    async () => {
      const data = await fetchBrandKits(currentWorkspaceId)
      return data?.brand_kits ?? []
    },
    {
      refetchOnWindowFocus: false,
      staleTime: (options?.cacheTime || 0) * 0.5,
      ...options,
    },
  )
}
